const translation = {
  title: '探索',
  sidebar: {
    discovery: '發現',
    chat: '智聊',
    workspace: '工作區',
    action: {
      pin: '置頂',
      unpin: '取消置頂',
      rename: '重新命名',
      delete: '刪除',
    },
    delete: {
      title: '刪除程式',
      content: '您確定要刪除此程式嗎？',
    },
  },
  apps: {
    title: '探索應用',
    description: '使用這些模板應用程式，或根據模板自定義您自己的應用程式。',
    allCategories: '推薦',
  },
  appCard: {
    addToWorkspace: '新增到工作區',
    customize: '自定義',
  },
  appCustomize: {
    title: '從 {{name}} 建立應用程式',
    subTitle: '應用程式圖示和名稱',
    nameRequired: '應用程式名稱不能為空',
  },
  category: {
    Assistant: '助手',
    Writing: '寫作',
    Translate: '翻譯',
    Programming: '程式設計',
    HR: '人力資源',
    Agent: '代理',
    Workflow: '工作流',
    Entertainment: '娛樂',
  },
}

export default translation
